import moment from "moment";

export const servicePath = `${process.env.REACT_APP_API_ENDPOINT}`;

export const steps1 = [
  {
    id: 1,
    name: "Cash",
    status: true,
    created_at: "2024-11-06T07:42:45",
    updated_at: "2024-11-06T07:42:45",
  },
  {
    id: 2,
    name: "Stock",
    status: true,
    created_at: "2024-11-06T06:00:25",
    updated_at: "2024-11-06T06:00:25",
  },
  {
    id: 3,
    name: "Real Estate",
    status: true,
    created_at: "2024-11-06T06:00:39",
    updated_at: "2024-11-06T06:00:39",
  },
  {
    id: 4,
    name: "Luxury Asset",
    status: true,
    created_at: "2024-11-06T06:02:25",
    updated_at: "2024-11-06T06:02:25",
  },
  {
    id: 5,
    name: "Company",
    status: true,
    created_at: "2024-11-06T06:01:06",
    updated_at: "2024-11-06T06:01:06",
  },
  {
    id: 6,
    name: "Pension",
    status: true,
    created_at: "2024-11-06T06:01:18",
    updated_at: "2024-11-06T06:01:18",
  },
];

export const filterDropdownOptions = [
  { name: "All" },
  { name: "INCOME" },
  { name: "EXPENSE" },
  { name: "IN" },
  { name: "OUT" },
];

export const Transactionsteps = [
  {
    id: 1,
    name: "Cash",
    status: true,
    created_at: "2024-11-06T07:42:45",
    updated_at: "2024-11-06T07:42:45",
  },
];

export const stockTransaction = [
  {
    id: 2,
    name: "Stock",
    status: true,
    created_at: "2024-11-06T07:42:45",
    updated_at: "2024-11-06T07:42:45",
  },
];

export const RealStateTransaction = [
  {
    id: 3,
    name: "Real Estate",
    status: true,
    created_at: "2024-11-06T07:42:45",
    updated_at: "2024-11-06T07:42:45",
  },
];

export const LuxaryAssetsTransaction = [
  {
    id: 4,
    name: "Luxary Assets",
    status: true,
    created_at: "2024-11-06T07:42:45",
    updated_at: "2024-11-06T07:42:45",
  },
];

export const CompanyTransaction = [
  {
    id: 5,
    name: "Company",
    status: true,
    created_at: "2024-11-06T07:42:45",
    updated_at: "2024-11-06T07:42:45",
  },
];

export const itemType = [
  {
    name: "Watch",
    value: "watch",
  },
  {
    name: "Car",
    value: "car",
  },
  {
    name: "Boat",
    value: "boat",
  },
  {
    name: "Wine",
    value: "wine",
  },
  {
    name: "Painting",
    value: "painting",
  },
  {
    name: "Collection",
    value: "collection",
  },
  {
    name: "Jewellery",
    value: "jewellery",
  },
  {
    name: "Ungrouped",
    value: "ungrouped",
  },
];

export const dropdownOptions = [
  {
    id: 1,
    name: "Income",
  },
  {
    id: 2,
    name: "Expenses",
  },
  {
    id: 3,
    name: "In",
  },
  {
    id: 4,
    name: "Out",
  },
];
export const steps = [
  {
    id: 1,
    name: "Assets",
  },
  {
    id: 2,
    name: "Liability",
  },
  {
    id: 3,
    name: "Structure",
  },
];

export const sectorss = [
  { value: "fc", name: "Financial Services" },
  { value: "CA", name: "Consumer Goods (Luxury)" },
  { value: "FR", name: "Pharmaceuticals" },
  { value: "DE", name: "Technology" },
  { value: "IM", name: "Industrial Manufacturing" },
  { value: "RE", name: "Real Estate" },
  { value: "HC", name: "Healthcare" },
  { value: "EG", name: "Energy" },
  { value: "RT", name: "Retail" },
  { value: "TC", name: "Telecommunications" },
  { value: "TL", name: "Transportation & Logistics" },
  { value: "UT", name: "Utilities" },
];

export const companyAssetTypeOption = [
  { value: "Bond", name: "Bond" },
  { value: "Derivative", name: "Derivative" },
  { value: "Fund/ETF", name: "Fund/ETF" },
  { value: "Stock", name: "Stock" },
  { value: "Other", name: "Other" },
  { value: "Private Equity", name: "Private Equity" },
  { value: "Loan", name: "Loan" },
  { value: "Company", name: "Company" },
];

export const owernershipTypeOption = [
  { value: "Majority ownership", name: "Majority Ownership" },
  { value: "Joint control", name: "Joint Control" },
  { value: "Minority ownership", name: "Minority Ownership" },
];

export const assetTypeOption = [
  { value: "PE", name: "Private Equity" },
  { value: "BA", name: "Business" },
  { value: "LA", name: "Luxury Asset" },
  { value: "RE", name: "Real Estate" },
  { value: "LD", name: "Liquidity" },
];

export const assetTypeStockOption = [{ value: "ST", name: "Stock" }];

export const assetTypeRealEstateOption = [{ value: "RE", name: "Real Estate" }];

export const debtType = [{ value: "La", name: "LombardLoan" }];

export const currencyOption = [
  { label: "CHF - Swiss franc", value: "CHF" },
  { label: "EUR - Euro", value: "EUR" },
  { label: "GBP - British Pound", value: "GBP" },
];

export const dateModeOptions = [
  { name: "YTD", value: "ytd" },
  { name: "Period", value: "range" },
];

export const healthDropdownOptions = [
  {
    name: "Asset",
    subOptions: [
      { id: 1, name: "Cash" },
      { id: 2, name: "Stock" },
      { id: 3, name: "Real Estate" },
      { id: 4, name: "Luxury Asset" },
      { id: 5, name: "Company" },
      { id: 6, name: "Pension" },
    ],
  },
  { name: "Liability" },
  { name: "Structure" },
];

export const relations = [
  "Father",
  "Mother",
  "Son",
  "Daughter",
  "Brother",
  "Sister",
  "Grandfather",
  "Grandmother",
  "Grandson",
  "Granddaughter",
  "Husband",
  "Wife",
  "Fiancé",
  "Fiancée",
  "Guardian",
  "Ward",
  "Other",
  "Self",
];

export const generateDaysArray = (date) => {
  const daysInMonth = moment(date).daysInMonth();
  return Array.from({ length: daysInMonth }, (_, i) => ({
    name: (i + 1).toString(),
    value: i + 1,
  }));
};

export const wealthAssetTypeOption = [
  { value: "PE", name: "Private Equity" },
  { value: "BA", name: "Business" },
  { value: "LA", name: "Luxury Asset" },
  { value: "RE", name: "Real Estate" },
  { value: "LD", name: "Liquidity" },
  { value: "LD", name: "Liquidity" },
  { value: "ST", name: "Stock" },
];
